import React from "react";

const RefineIcon = ({ size = 30 }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 30 30">
    <g>
      <g transform="rotate(-180 13.5 13.5)">
        <g>
          <g>
            <path
              fill="none"
              stroke="#002c90"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeMiterlimit="50"
              strokeWidth="2"
              d="M12.436 1.305v24.39"
            />
          </g>
          <g>
            <path
              fill="#fff"
              d="M12.435 11.42c1.67 0 3.024-1.4 3.024-3.125 0-1.726-1.354-3.125-3.024-3.125S9.41 6.57 9.41 8.295c0 1.726 1.354 3.125 3.025 3.125z"
            />
            <path
              fill="none"
              stroke="#002c90"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeMiterlimit="50"
              strokeWidth="2"
              d="M12.435 11.42c1.67 0 3.024-1.4 3.024-3.125 0-1.726-1.354-3.125-3.024-3.125S9.41 6.57 9.41 8.295c0 1.726 1.354 3.125 3.025 3.125z"
            />
          </g>
        </g>
        <g transform="matrix(1 0 0 -1 0 27)">
          <g>
            <path
              fill="none"
              stroke="#002c90"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeMiterlimit="50"
              strokeWidth="2"
              d="M21.846 1.305v24.39"
            />
          </g>
          <g>
            <path
              fill="#fff"
              d="M21.845 11.42c1.67 0 3.024-1.4 3.024-3.125 0-1.726-1.354-3.125-3.024-3.125s-3.025 1.4-3.025 3.125c0 1.726 1.354 3.125 3.025 3.125z"
            />
            <path
              fill="none"
              stroke="#002c90"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeMiterlimit="50"
              strokeWidth="2"
              d="M21.845 11.42c1.67 0 3.024-1.4 3.024-3.125 0-1.726-1.354-3.125-3.024-3.125s-3.025 1.4-3.025 3.125c0 1.726 1.354 3.125 3.025 3.125z"
            />
          </g>
        </g>
        <g transform="matrix(1 0 0 -1 0 27)">
          <g>
            <path
              fill="none"
              stroke="#002c90"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeMiterlimit="50"
              strokeWidth="2"
              d="M3.026 1.305v24.39"
            />
          </g>
          <g>
            <path
              fill="#fff"
              d="M3.025 11.42c1.67 0 3.024-1.4 3.024-3.125 0-1.726-1.354-3.125-3.024-3.125S0 6.57 0 8.295c0 1.726 1.354 3.125 3.025 3.125z"
            />
            <path
              fill="none"
              stroke="#002c90"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeMiterlimit="50"
              strokeWidth="2"
              d="M3.025 11.42c1.67 0 3.024-1.4 3.024-3.125 0-1.726-1.354-3.125-3.024-3.125S0 6.57 0 8.295c0 1.726 1.354 3.125 3.025 3.125z"
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export default RefineIcon;
